export default __webpack_public_path__ + "static/preround-1bd1475b0a511c1c5adae169686bab0f.png";